import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Flame, Phone } from 'lucide-react';
export function Popup() {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    // Show popup after 4 seconds
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);
  return <AnimatePresence data-id="element-182" data-mp="380edpjitrtsv">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-id="element-183" data-mp="381ft206vj2ge">
          <motion.div initial={{
        scale: 0.9,
        opacity: 0,
        y: 20
      }} animate={{
        scale: 1,
        opacity: 1,
        y: 0
      }} exit={{
        scale: 0.9,
        opacity: 0,
        y: 20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="relative w-full max-w-md bg-[#0a0a0a] border border-white/10 rounded-3xl p-8 shadow-[0_20px_60px_-15px_rgba(255,149,0,0.3)] overflow-hidden" data-id="element-184" data-mp="3cyfw028ffp3a">
            {/* Decorative Background Elements */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-primary" data-id="element-185" data-mp="30v5uaj98qlzy"></div>
            <div className="absolute -top-20 -right-20 w-40 h-40 bg-[#FF9500] rounded-full blur-[80px] opacity-20 pointer-events-none" data-id="element-186" data-mp="35sxjv6mexw0z"></div>

            <button onClick={() => setIsOpen(false)} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white/5 text-gray-400 hover:text-white hover:bg-white/10 transition-colors" aria-label="Close popup" data-id="element-187" data-mp="3ekpv3jj9h96m">
              <X className="w-4 h-4" data-id="element-188" data-mp="3pf2nrmsf3hmw" />
            </button>

            <div className="w-12 h-12 rounded-full bg-gradient-primary p-[1px] mb-6 shadow-lg" data-id="element-189" data-mp="3pdhus1lr46r5">
              <div className="w-full h-full bg-[#0a0a0a] rounded-full flex items-center justify-center" data-id="element-190" data-mp="3kfzhjz0pb5dc">
                <Flame className="w-6 h-6 text-[#FF9500]" data-id="element-191" data-mp="2yyiqbk913nu" />
              </div>
            </div>

            <h3 className="text-2xl font-black text-white mb-2" data-id="element-192" data-mp="3u6uf3zjedre3">
              Need an Emergency Repair?
            </h3>
            <p className="text-gray-400 mb-8 leading-relaxed text-sm" data-id="element-193" data-mp="36ib6fiwfrclh">
              Our Gas Safe engineers are available 24/7 across Glasgow and
              Clydeside. Don't stay in the cold — we're ready to help right now.
            </p>

            <div className="flex flex-col gap-3" data-id="element-194" data-mp="3bei3em6utdra">
              <a href="tel:07708233554" className="flex items-center justify-center gap-2 bg-gradient-primary text-black font-bold py-3.5 rounded-xl hover:shadow-[0_0_25px_rgba(255,149,0,0.4)] transition-all transform hover:-translate-y-0.5" data-id="element-195" data-mp="3bhxllxvtr2wx">
                <Phone className="w-5 h-5" data-id="element-196" data-mp="yaxw9ruf2hcm" />
                Call 07708 233554
              </a>
              <button onClick={() => setIsOpen(false)} className="text-sm font-medium text-gray-500 hover:text-white transition-colors py-2" data-id="element-197" data-mp="135v6v37cgyrm">
                No thanks, maybe later
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}